export default function getQueryParams(params) {
  const cleanParams = Object.keys(params)?.reduce((acc, keyParam) => {
    if (params[keyParam] !== null && params[keyParam] !== undefined) {
      acc[keyParam] = params[keyParam];
    }
    return acc;
  }, {}) ?? {};

  return new URLSearchParams(cleanParams).toString();
}